import { useMemo } from "react";
import { Link, useNavigate } from "react-router";

import { Typography } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid";
import TilleyDataGrid from "components/shared/DataGrid/TilleyDataGrid";
import { CustomWidthTooltip } from "mui-toolkit/CustomWidthTooltip";
import DeleteConfirmationButton from "mui-toolkit/DeleteConfirmationButton";

import { EditIcon } from "../../../Icons/Icons";

export default function ProducerFarmFieldCropDataGrid({ onChange, producerFarmFieldCrops, isLoading = false }) {
  const navigate = useNavigate();

  const COLUMNS_PRODUCERFARMFIELDCROP = useMemo(
    () => [
      {
        field: "commodity_name",
        headerName: "Commodity",
        flex: 1,
        renderCell: (params) => (
          <Typography color="primary" component={Link} to={`./${params?.row?.id}`}>
            {params.value}
          </Typography>
        ),
      },
      {
        field: "crop_year",
        headerName: "Year",
        flex: 1,
      },
      {
        field: "type_name",
        headerName: "Type",
        flex: 1,
      },
      {
        field: "practice_name",
        headerName: "Practice",
        flex: 1,
      },
      {
        field: "approved_yield",
        headerName: "APH",
        flex: 1,
      },
      {
        field: "rate_yield",
        headerName: "Rate",
        flex: 1,
      },
      {
        field: "reported_acreage",
        headerName: "Acres",
        flex: 1,
      },
      {
        field: "actions",
        headerName: "Actions",
        type: "actions",
        headerAlign: "right",
        align: "right",
        width: 100,
        sortable: false,
        getActions: (params) => [
          <CustomWidthTooltip key="delete" title="Delete" placement="top" arrow>
            <DeleteConfirmationButton item={params.row} onChange={onChange} />
          </CustomWidthTooltip>,

          <CustomWidthTooltip key="edit" title="Edit" placement="top" arrow>
            <GridActionsCellItem
              key="view"
              icon={<EditIcon />}
              label="View Details"
              onClick={() => {
                navigate(`./${params?.row?.id}`);
              }}
            />
          </CustomWidthTooltip>,
        ],
        flex: 0,
      },
    ],
    [navigate]
  );

  return (
    <>
      <TilleyDataGrid
        rows={producerFarmFieldCrops || []}
        columns={COLUMNS_PRODUCERFARMFIELDCROP}
        pageSizeOptions={[5, 10, 25]}
        defaultPageSize={5}
        gridKey="producer-farm-field-crops"
        getRowId={(row) => row.id}
        isLoading={isLoading}
      />
    </>
  );
}
